export const cleanKey = (str: string) => str.replace(' / ', '').replace(' ', '');

export const sortByIndex = (arr: any, str: string, sortBy: string) =>
  arr?.length > 0 &&
  arr.sort((a: any, b: any) => {
    return a[sortBy]?.toLowerCase().indexOf(str.toLowerCase()) > b[sortBy]?.toLowerCase().indexOf(str.toLowerCase())
      ? 1
      : -1;
  });
